module.exports = __webpack_public_path__ + "static/img/star1-yellow.dfa84f98.png";